import { defineMessages } from 'react-intl';
import configs from "configs"

export const scope = 'app.components.Quotation';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Stampa questa offerta',
  },
  button: {
    id: `${scope}.button`,
    defaultMessage: 'Configura e procedi',
  },
  terms: {
    id: `${scope}.terms`,
    defaultMessage:
      'Il prezzo del canone mensile è soggetto a variazioni. Offerta economica limitata valida fino ad esaurimento scorte.',
  },
  confirm_terms: {
    id: `${scope}.confirm_terms`,
    defaultMessage:
      "Confermo di essere a conoscenza che il prezzo del canone mensile è soggetto a variazioni e che l'offerta economica è limitata e valida fino ad esaurimento scorte",
  },
  sidebar_recap_title_1: {
    id: `${scope}.sidebar_recap_title_1`,
    defaultMessage: "Cosa c'è da sapere su questa {car_title}",
    tagName: 'strong',
  },
  sidebar_recap_title_2: {
    id: `${scope}.sidebar_recap_title_2`,
    defaultMessage: 'Dati preventivo',
    tagName: 'strong',
  },
  equippedOptionals: {
    id: `${scope}.equippedOptionals`,
    defaultMessage: 'Optional inclusi',
    tagName: 'strong',
  },
  sidebar_recap_title_3: {
    id: `${scope}.sidebar_recap_title_3`,
    defaultMessage: 'Servizi inclusi',
    tagName: 'strong',
  },
  sidebar_recap_title_4: {
    id: `${scope}.sidebar_recap_title_4`,
    defaultMessage: 'Optional aggiuntivi',
    tagName: 'strong',
  },
  sidebar_recap_title_5: {
    id: `${scope}.sidebar_recap_title_5`,
    defaultMessage: 'Note preventivo',
    tagName: 'strong',
  },
  sidebar_recap_title_6: {
    id: `${scope}.sidebar_recap_title_6`,
    defaultMessage: 'Termini e condizioni',
    tagName: 'strong',
  },
  sidebar_recap_title_7: {
    id: `${scope}.sidebar_recap_title_7`,
    defaultMessage: 'Dati venditore',
    tagName: 'strong',
  },
  no_one: {
    id: `${scope}.no_one`,
    defaultMessage: 'Nessuno',
    tagName: 'em',
  },
  service_change_tires: {
    id: `${scope}.service_change_tires`,
    defaultMessage: 'Pneumatici',
  },
  service_car_replacement: {
    id: `${scope}.service_car_replacement`,
    defaultMessage: 'Vettura sostitutiva',
  },
  service_copertura_assicurativa: {
    id: `${scope}.copertura_assicurativa`,
    defaultMessage: 'Copertura Assicurativa Totale',
  },
  service_pai: {
    id: `${scope}.service_pai`,
    defaultMessage: 'Pai Totale',
  },
  service_tutela_legale: {
    id: `${scope}.service_tutela_legale`,
    defaultMessage: 'Tutela Legale',
  },
  service_assistenza_stradale: {
    id: `${scope}.service_assistenza_stradale`,
    defaultMessage: 'Assistenza Stradale',
  },
  continue: {
    id: `${scope}.continue`,
    defaultMessage: 'Prosegui',
  },
  ahead: {
    id: `${scope}.ahead`,
    defaultMessage: 'Avanti',
  },
  back: {
    id: `${scope}.back`,
    defaultMessage: 'Indietro',
  },
  backToOffer: {
    id: `${scope}.backToOffer`,
    defaultMessage: "Torna all'offerta",
  },
  alertError: {
    id: `${scope}.alertError`,
    defaultMessage:
      'Si sono verificati degli errori, controllare i dati inseriti',
  },
  serverError: {
    id: `${scope}.serverError`,
    defaultMessage:
      "Si è verificato un problema durante l'operazione, si prega di riprovare",
  },
  contractualsCategories: {
    id: `${scope}.contractualsCategories`,
    defaultMessage: 'Categoria contrattuale',
  },
  firstName: {
    id: `${scope}.firstName`,
    defaultMessage: 'Nome',
  },
  lastName: {
    id: `${scope}.lastName`,
    defaultMessage: 'Cognome',
  },
  fiscalCode: {
    id: `${scope}.fiscalCode`,
    defaultMessage: 'Codice fiscale',
  },
  fiscalCodePersonal: {
    id: `${scope}.fiscalCodePersonal`,
    defaultMessage: 'CF personale',
  },
  fiscalCodeTooltip: {
    id: `${scope}.fiscalCodeTooltip`,
    defaultMessage:
      'Indicare il codice fiscale della persona intestataria del contratto di noleggio a lungo termine',
  },
  fiscalCodeBusiness: {
    id: `${scope}.fiscalCodeBusiness`,
    defaultMessage: 'Codice fiscale attività',
  },
  fiscalCodeBusinessTooltip: {
    id: `${scope}.fiscalCodeBusinessTooltip`,
    defaultMessage:
      'Indicare il codice fiscale dell\'attività a cui verrà intestato il contratto di noleggio a lungo termine',
  },
  fiscalCodeError: {
    id: `${scope}.fiscalCodeError`,
    defaultMessage: 'Il codice fiscale indicato non è valido',
  },
  vatNumber: {
    id: `${scope}.vatNumber`,
    defaultMessage: 'Partita IVA',
  },
  pec: {
    id: `${scope}.pec`,
    defaultMessage: 'Indirizzo PEC',
  },
  sdiCode: {
    id: `${scope}.sdiCode`,
    defaultMessage: 'Codice SDI',
  },
  businessName: {
    id: `${scope}.businessName`,
    defaultMessage: 'Ragione sociale',
  },
  sdi_code: {
    id: `${scope}.sdi_code`,
    defaultMessage: 'SDI',
  },
  phone: {
    id: `${scope}.phone`,
    defaultMessage: 'Telefono',
  },
  zipCode: {
    id: `${scope}.zipCode`,
    defaultMessage: 'Cap',
  },
  city: {
    id: `${scope}.city`,
    defaultMessage: 'Comune',
  },
  notes: {
    id: `${scope}.notes`,
    defaultMessage: 'Note',
  },
  phoneNotValid: {
    id: `${scope}.phoneNotValid`,
    defaultMessage: 'Indicare un numero di telefono valido',
  },
  zipCodeNotValid: {
    id: `${scope}.zipCodeNotValid`,
    defaultMessage: 'Indicare un CAP valido',
  },
  formConfirmDescription: {
    id: `${scope}.formConfirmDescription`,
    defaultMessage:
      'Verifica la correttezza dei dati inseriti per procedere con la richiesta. Clicca su Indietro per modificarli. Una volta confermati non saranno più modificabili. Dalla sezione riepilogo a destra puoi anche scaricare il preventivo.',
  },
  documentsUploadDescription: {
    id: `${scope}.documentsUploadDescription`,
    defaultMessage:
      'Carica tutti i documenti richiesti per finalizzare la richiesta di preventivo',
  },
  vat: {
    id: `${scope}.vat`,
    defaultMessage: configs.messages[scope].vat,
  },
  vatNotice: {
    id: `${scope}.vatNotice`,
    defaultMessage:  configs.messages[scope].vatNotice,
  },
  vatNoticeDescription: {
    id: `${scope}.vatNoticeDescription`,
    defaultMessage:  configs.messages[scope].vatNoticeDescription,
  }

});
